<template>
  <div class="publicCert">
    <img class="logoImg" :src="logo">
    <h1>证书查询系统</h1>
    <section>
      <van-tabs v-model="active" :color="color">
        <van-tab title="身份证号">
          <van-field v-model="cert.certName" maxlength="18" label="身份证号" placeholder="请输入身份证号" />
        </van-tab>
        <van-tab title="证书编号">
          <van-field v-model="cert.certNumber" maxlength="21" label="证书编号" placeholder="请输入证书编号" />
        </van-tab>
      </van-tabs>
      <van-button :style="{ backgroundColor: color, border: '0.02667rem solid' + color }" type="primary" size="large" :loading="loading" :disabled="loading" loading-text="查询中..." @click="submit">立即查询</van-button>
    </section>
    <div class="footer">
      <p>北京阿叟阿巴科技有限公司</p>
      <p>ALSOLIFE 2017 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Field, Button, Tab, Tabs, Toast } from 'vant'
export default {
  name: 'PublicCert',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  props: {
    logo: { // Logo图片
      type: String,
      default: ''
    },
    type: { // 查询证书的证书类型
      type: String,
      default: ''
    },
    color: { // 按钮颜色和tab字体的颜色
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: '',
      cert: {
        certName: '',
        certNumber: ''
      },
      loading: false // 立即查询的按钮是否加载状态
    }
  },
  created () {
    localStorage.removeItem('CertResulttNum')
  },
  mounted () {},
  methods: {
    submit() {
      let query = {}
      query.type = this.type
      if (this.active == 0) {
        if (this.cert.certName === '') {
          Toast('\n身份证号输入框不能为空\n请输入身份证号\n\n')
        } else {
          // 身份证号
          query.id = this.cert.certName
          this.getCertInfo(query)
        }
      } else {
        if (this.cert.certNumber === '') {
          Toast('\n证书编号输入框不能为空\n请输入证书编号\n\n')
        } else {
          // 证书编号
          query.number = this.cert.certNumber
          this.getCertInfo(query)
        }
      }
    },
    getCertInfo(query) {
      this.loading = true
      this.$router.push({ name: 'result', query: { data: JSON.stringify(query) } })
    }
  }
}
</script>

<style lang="less" scoped>
.publicCert{
  .logoImg{ // logo图片
      margin: 10vw auto 0;
    width: auto;
    height: 40vw;
    display: block;
  }
  h1 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 10vw
  }
	section {
		padding: 10px;
		margin-bottom: 20vw;
		// margin-bottom: 43.5vw;
	}
  ::v-deep .van-tab__pane{ // 标签的内容
    padding-top: 20px;
  }
  ::v-deep .van-button { // 立即查询按钮
    margin-top: 10vw;
  }
  .footer { // 底部版权
    padding-bottom: 10vw;
    p {
        font-size: 12px;
        text-align: center;
        color: rgba(0, 0, 0, .4);
    }
	}
}
</style>
